const NEW_TAB_TARGET = '_blank';

export function openInNewTab(url: string): void {
	const anchor = document.createElement('a');
	anchor.target = NEW_TAB_TARGET;
	anchor.href = url;
	anchor.click();
	anchor.remove();
}
